import { Holding, valuationStatusOf } from "../../../../../services/holdings";
import { valuationAmountText } from "../../../../../services/valuation";
import { formatPercent } from "../../../../../utils";
import { currencyOrDash } from "../../../utils";
import { ContextMetric } from "./types";

export const positionMetrics = (holding: Holding): ContextMetric[] => [
  {
    label: "Unrealized",
    value: valuationAmountText({
      value: holding.unrealizedReturnValue,
      valuation: valuationStatusOf(holding),
    }),
  },
  { label: "Realized", value: currencyOrDash(holding.realizedReturnValue) },
  { label: "Gross income", value: currencyOrDash(holding.totalIncome) },
  { label: "Tax withheld", value: currencyOrDash(holding.withholdingTaxCosts) },
  { label: "Net received", value: currencyOrDash(holding.netIncome) },
  // A dash, not "Unavailable": an allocation is withheld by the account's completeness, not this holding's valuation.
  { label: "Portfolio share", value: formatPercent(holding.allocationPercent) },
];
